module.exports = __webpack_public_path__ + "img/GoldUpIconDemoBlancFichier 18@4x-8.75f1a4b8.png";